import { render, staticRenderFns } from "./CreateTemplate.vue?vue&type=template&id=1242c16f&scoped=true&"
import script from "./CreateTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242c16f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1242c16f')) {
      api.createRecord('1242c16f', component.options)
    } else {
      api.reload('1242c16f', component.options)
    }
    module.hot.accept("./CreateTemplate.vue?vue&type=template&id=1242c16f&scoped=true&", function () {
      api.rerender('1242c16f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Marketing/CreateTemplate.vue"
export default component.exports